import { render, staticRenderFns } from "./singleUserDetails.vue?vue&type=template&id=2a83d112&scoped=true&"
import script from "./singleUserDetails.vue?vue&type=script&lang=js&"
export * from "./singleUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a83d112",
  null
  
)

component.options.__file = "singleUserDetails.vue"
export default component.exports